// extracted by mini-css-extract-plugin
export default {"root":"FilterGroup__root--GXTTC","header":"FilterGroup__header--r5SEd"};